// @flow
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import update from 'immutability-helper';
import { defineMessages, FormattedMessage, intlShape } from 'react-intl';
import { generateTags } from '../../../../elements/Filter/utils';
import classNames from 'classnames/bind';
import Loading from '../../../../elements/Loading/Loading';
import Filter from '../../../../elements/Filter/Filter';
import FilterDrawer from '../../../../elements/Filter/Drawer/FilterDrawer';
import InfiniteScroll from '../../../../elements/InfiniteScroll/InfiniteScroll';
import {Desktop, UntilTablet} from '../../../../utils/responsive';
import AlertContainer from '../../../alert/container/AlertContainer';
import analytics from '../../../../analytics';
import FlightShare from '../FlightShare/FlightShare';
import OrderBox from '../OrderBox/OrderBox';
import Modal from '../../../../elements/Modal/Modal';
import AwardCounter from '../AwardCounter/AwardCounter';
import ProductsLimits from '../ProductsLimits/ProductsLimits';

import style from './OrdersRequests.scss';
import commonStyle from '../Flight.scss';
import filterOptionsStyle from '../../../../assets/styles/filter-options.scss';
import filterStyles from '../../../../assets/styles/filter.scss';
import icons from '../../../../assets/styles/icons.scss';
import buttonStyle from '../../../../assets/styles/button.scss';
import yogi from '../../../../assets/img/Yogi_sad2.png';

import type { LocalValuesState } from '../../../local-values/duck';
import type {Category, Flight, OnlineStore, Order, User} from '../../../../entities';
import type { Match } from '../../../../router';
import type { FilterCheckbox, FilterRadioButton } from '../../../../elements/Filter/Filter';
import type { HTTPError } from '../../../../error';
import type { LocaleState } from '../../../locale/duck';
import type { TravelerReward } from '../../duck';

type Props = {
  +resetOrderRequestsState: () => void;
  +localeState: LocaleState;
  +localValues: LocalValuesState;
  +page: number;
  +canAsk?: boolean;
  +availableOrders?: Order[];
  +isFetchingAvailable?: boolean;
  +fetchAvailableRequests: (id: string, queryFilter?: { [key: string]: string }, resetPagination?: boolean) => void;
  +fetchRequestsError?: HTTPError;
  +match: Match;
  +fetchOnlineStores: () => void;
  +fetchFlightTravelerReward: (id: string) => void;
  +isFetchingReward: boolean;
  +travelerReward: TravelerReward;
  //+isFetchingOnlineStores: boolean;
  //+onlineStores?: OnlineStore[];
  //+fetchOnlineStoresError?: HTTPError;
  +resetAlertState: () => void;
  +flight?: Flight;
  +user?: User;
};

type State = {
  drawerOpen: boolean;
  filter: {
    name: {
      value: string;
    };
    openName: boolean;
    categories: {
      [key: string]: boolean;
    };
    openCategories: boolean;
    stores: {
      [key: string]: boolean;
    };
    openStores: boolean;
  };
  sort: {
    value: string;
    name: string;
  };
  order: {
    value: 'ASC' | 'DESC';
  };
  alreadyBookedModalOpen: boolean;
  shareFlightModalOpen: boolean;
};

const messages = defineMessages({
  title: {
    id: 'flight.requests.document.title',
  },
  description: {
    id: 'flight.requests.document.description',
  },
  sortPlaceholder: {
    id: 'sort.title',
  },
  sortClosestToDeliver: {
    id: 'sort.option.closestToDeliver',
  },
  sortFarthestToDeliver: {
    id: 'sort.option.farthestToDeliver',
  },
  sortHighestCommission: {
    id: 'sort.option.highestCommission',
  },
  sortLowestCommission: {
    id: 'sort.option.lowestCommission',
  },
  sortHighestTotalValue: {
    id: 'sort.option.highestTotalValue',
  },
  sortLowestTotalValue: {
    id: 'sort.option.lowestTotalValue',
  },
});

const initialState = {
  drawerOpen: false,
  filter: {
    name: {
      value: '',
    },
    openName: true,
    categories: {},
    openCategories: true,
    stores: {},
    openStores: false,
  },
  sort: {
    value: '',
    name: '',
  },
  order: {
    value: 'DESC',
  },
  alreadyBookedModalOpen: false,
  shareFlightModalOpen: false,
};

const limitsPE: { intl: string, number: number }[] = [
  { intl: 'flight.requests.productLimits.modal.table.laptop', number: 1 },
  { intl: 'flight.requests.productLimits.modal.table.camera', number: 1 },
  { intl: 'flight.requests.productLimits.modal.table.cellphones', number: 2 },
  { intl: 'flight.requests.productLimits.modal.table.tablets', number: 1 },
  { intl: 'flight.requests.productLimits.modal.table.shoes', number: 4 },
  { intl: 'flight.requests.productLimits.modal.table.makeUp', number: 5 },
  { intl: 'flight.requests.productLimits.modal.table.lotions', number: 4 },
  { intl: 'flight.requests.productLimits.modal.table.perfumes', number: 4 },
  { intl: 'flight.requests.productLimits.modal.table.vitamins', number: 5 },
];

export default class OrderRequest extends Component<Props, State> {
  urlIdFlight: string;
  state = initialState;

  constructor(props: Props) {
    super(props);
    if (props.match.params) this.urlIdFlight = props.match.params.id;
  }

  // Only in browser
  componentDidMount() {
    const {
      fetchAvailableRequests, availableOrders, fetchFlightTravelerReward, travelerReward, flight,
      localeState, fetchRequestsError,
    } = this.props;
    if (!availableOrders) fetchAvailableRequests(this.urlIdFlight, this.buildQueryParams(), true);
    //if (!onlineStores) fetchOnlineStores();
    this.fireEvent();
    /*if (!travelerReward && !!flight) {
      fetchFlightTravelerReward(flight.id);
    }*/

    if (!!fetchRequestsError && !!fetchRequestsError.data && fetchRequestsError.data.name === 'OrderAlreadyBooked') {
      this.setState({ alreadyBookedModalOpen: true });
    }
  }

  componentWillUnmount() {
    const { resetOrderRequestsState, resetAlertState } = this.props;
    resetOrderRequestsState();
    resetAlertState();
  }

  componentDidUpdate = (prevProps: Props) => {
    const {
      fetchFlightTravelerReward, travelerReward, flight,
    } = this.props;

    /*if (!travelerReward && !prevProps.flight && !!flight) {
      fetchFlightTravelerReward(flight.id);
    }*/
  };

  fireEvent() {
    const { localeState, localValues } = this.props;
    const { sort, order, filter } = this.state;
    const categories = Object.keys(filter.categories)
      .filter((category: string) => filter.categories[category])
      .map((category: string) => localValues.categoriesMap && localValues.categoriesMap[category].seoUrl);
    const name = filter.name.value;
    analytics.fireCustomEvent('Available Orders Viewed', {
      category: 'Available Orders',
      action: 'Viewed',
      user_type: 'traveler',
      user_referrer: window.localStorage.getItem('userReferrer') || '',
      landing_url: window.localStorage.getItem('landingUrl') || '',
      flight_id: this.urlIdFlight,
      filters: {
        categories,
        name,
      },
      sort: sort.name,
      sort_order: order.value,
      domain_country: localeState.domainCountry,
    });
  }

  handleOpenDrawer = () => {
    this.setState({ drawerOpen: true });
  };

  handleCloseDrawer = () => {
    const { fetchAvailableRequests } = this.props;
    this.setState({
      drawerOpen: false,
    });
    fetchAvailableRequests(this.urlIdFlight, this.buildQueryParams(), true);
  };

  handleChangeName(e: Event, isDesktop: boolean = true) {
    if (e.target instanceof HTMLInputElement) {
      const { value } = e.target;
      this.handleChangeFilterValueCreator(isDesktop)('name', { value });
    }
  }

  handleChangeCategory(e: Event, isDesktop: boolean = true) {
    const { filter } = this.state;
    if (e.target instanceof HTMLInputElement) {
      const { value } = e.target;
      this.handleChangeFilterValueCreator(isDesktop)('categories', { [value]: !filter.categories[value] });
    }
  }

  handleChangeStore(e: Event, isDesktop: boolean = true) {
    const { filter } = this.state;
    if (e.target instanceof HTMLInputElement) {
      const { value } = e.target;
      this.handleChangeFilterValueCreator(isDesktop)('stores', { [value]: !filter.stores[value] });
    }
  }

  buildQueryParams(): { [key: string]: any } {
    const params = {};
    const { filter, sort, order } = this.state;
    const categories = Object.keys(filter.categories)
      .reduce((acum, act: string) => filter.categories[act] ? acum.concat(act) : acum, []);
    const stores = Object.keys(filter.stores)
      .reduce((acum, act: string) => filter.stores[act] ? acum.concat(act) : acum, []);
    if (filter.name.value) {
      params.name = filter.name.value;
    }
    if (categories.length) {
      params.categories = categories.join(',');
    }
    if (stores.length) {
      params.storeIds = stores.join(',');
    }
    // Sort & Ord
    if (sort.name) {
      params.sort = sort.name;
    }
    if (order.value) {
      params.order = order.value;
    }
    return params;
  }

  handleChangeSort = (e: Event) => {
    const { fetchAvailableRequests } = this.props;
    if (e.target instanceof HTMLSelectElement) {
      const option = e.target.options[e.target.selectedIndex];
      const dataset: { sort: string, order: 'ASC' | 'DESC' } = (option.dataset: any);
      this.fireEvent();
      this.setState({
        sort: {
          value: option.value,
          name: dataset.sort,
        },
        order: {
          value: dataset.order,
        },
      }, () => fetchAvailableRequests(this.urlIdFlight, this.buildQueryParams(), true));
    }
  };

  handleClearFilters = () => {
    const { fetchAvailableRequests } = this.props;
    this.setState(initialState,
      () => fetchAvailableRequests(this.urlIdFlight, this.buildQueryParams(), true));
  };

  handleDeleteTag = (key?: string, name?: string) => {
    const { fetchAvailableRequests } = this.props;
    const updateQuery = {};
    switch (key) {
      case 'categories':
      case 'stores':
        if (name) {
          updateQuery[key] = {
            [name]: { $set: false },
          };
        }
        break;
      case 'name':
        updateQuery[key] = {
          value: { $set: '' },
        };
        break;
    }
    this.setState((prevState: State) => update(prevState, {
      filter: updateQuery,
    }), () => fetchAvailableRequests(this.urlIdFlight, this.buildQueryParams(), true));
  };

  // Depends if desktop or mobile
  handleChangeFilterValueCreator = (isDesktop: boolean) =>
    (name: string, value: any) => {
      const { fetchAvailableRequests } = this.props;
      this.setState((state: State) => {
        const c = update(state.filter[name], { $merge: value });
        return {
          filter: update(state.filter, {
            [name]: { $set: c },
          }),
        };
      }, () => {
        if (isDesktop) {
          fetchAvailableRequests(this.urlIdFlight, this.buildQueryParams(), true);
        }
      });
    };

  handleOpen = (name: string) => {
    this.setState((state: State) => {
      return {
        filter: update(state.filter, {
          [name]: { $set: !state.filter[name] },
        }),
      };
    });
  };

  generateFilterFields = (categories: ?FilterCheckbox[], stores: ?FilterCheckbox[],
                          { filter }: State, isDesktop: boolean) => [
    {
      type: 'text',
      titleIntl: 'filter.name.title',
      placeholderIntl: 'filter.name.placeholder',
      handler: (e: Event) => this.handleChangeName(e, isDesktop),
      stateValue: filter.name,
      name: 'name',
      icon: icons.symbolSearch,
      isOpen: filter.openName,
      handleOpen: () => this.handleOpen('openName'),
    },
    {
      type: 'checkbox',
      titleIntl: 'filter.categories.title',
      handler: (e: Event) => this.handleChangeCategory(e, isDesktop),
      stateValue: filter.categories,
      name: 'categories',
      checkboxes: categories,
      isOpen: filter.openCategories,
      color: 'orange',
      handleOpen: () => this.handleOpen('openCategories'),
    },
    {
      type: 'checkbox',
      titleIntl: 'filter.stores.title',
      handler: (e: Event) => this.handleChangeStore(e, isDesktop),
      stateValue: filter.stores,
      name: 'stores',
      checkboxes: stores,
      isOpen: filter.openStores,
      color: 'orange',
      handleOpen: () => this.handleOpen('openStores'),
    },
  ];

  render() {
    const { drawerOpen, sort, alreadyBookedModalOpen, shareFlightModalOpen } = this.state;
    const {
      localValues, availableOrders, isFetchingAvailable, fetchAvailableRequests, canAsk,
      localeState, flight, travelerReward, isFetchingReward, user,
    } = this.props;
    const categories: ?FilterCheckbox[] = localValues.categories && localValues.categories.map((c: Category) => (
      {
        label: c.translations[localeState.locale.toUpperCase()].name,
        value: c.id.toString(),
      }
    ));

    const stores: ?FilterCheckbox[] = localValues.onlineStores && localValues.onlineStores.map((onlineStore: OnlineStore) => (
      {
        label: onlineStore.name,
        value: onlineStore.onlineStoreId.toString(),
      }
    ));
    const filterFields = this.generateFilterFields(categories, stores, this.state, true);
    const filterContent =
      <Filter filterFields={(this.generateFilterFields(categories, stores, this.state, true): any)}
              handleDeleteTag={this.handleDeleteTag}/>;
    const tags: any = generateTags((filterFields: any), this.handleDeleteTag, this.context.intl.formatMessage);
    const sortNativeSelect = (
      <select value={sort.value}
              onChange={this.handleChangeSort}>
        <option value="closestToDeliver" data-sort="DELIVERY_DATE"
                data-order="DESC">{this.context.intl.formatMessage(messages.sortClosestToDeliver)}</option>
        <option value="farthestToDeliver" data-sort="DELIVERY_DATE"
                data-order="ASC">{this.context.intl.formatMessage(messages.sortFarthestToDeliver)}</option>
        <option value="highestCommission" data-sort="COMMISSION"
                data-order="DESC">{this.context.intl.formatMessage(messages.sortHighestCommission)}</option>
        <option value="lowestCommission" data-sort="COMMISSION"
                data-order="ASC">{this.context.intl.formatMessage(messages.sortLowestCommission)}</option>
        <option value="highestTotalValue" data-sort="TOTAL"
                data-order="DESC">{this.context.intl.formatMessage(messages.sortHighestTotalValue)}</option>
        <option value="lowestTotalValue" data-sort="TOTAL"
                data-order="ASC">{this.context.intl.formatMessage(messages.sortLowestTotalValue)}</option>
      </select>
    );

    const dateTooFarError = (!availableOrders || !availableOrders.length) && !isFetchingAvailable;

    const orders = flight && availableOrders && availableOrders
      .filter((order: Order) => {
        // TODO: Might come back anytime soon
        const r = order.items.some(o => o.url.includes('amazon.com'));
        if (r) console.log(`[Ignoring due to Amazon]: ${order.id}`);
        return !r;
      })
      .map((order: Order, n: number) => <OrderBox key={n}
                                                  order={order}
                                                  flight={flight}
                                                  type='available'/>);

    return (
      <Fragment>
        <Helmet>
          <title>{this.context.intl.formatMessage(messages.title)}</title>
          <meta name="description" content={this.context.intl.formatMessage(messages.description)}/>
        </Helmet>
        <UntilTablet>
          <section className={classNames(commonStyle.mainWrap, commonStyle.noMinHeight)}>
            {flight && user && <FlightShare flight={flight}
                                            user={user}
                                            open={shareFlightModalOpen}
                                            handleClose={() => this.setState({shareFlightModalOpen: false})}
                                            handleOpen={() => this.setState({shareFlightModalOpen: true})}/>}
          </section>
        </UntilTablet>
        <section className={classNames(commonStyle.titleWrap, commonStyle.mobile)}>
          <i className={icons.iconBoxMedium}/>
          <section className={commonStyle.content}>
            <FormattedMessage id="flight.requests.title">{
              txt => <h3 className={commonStyle.title}>{txt}</h3>
            }</FormattedMessage>
            {flight && <p className={commonStyle.subtitle}>
              {flight.departureAdmin1.name} - {flight.arrivalAdmin1.name}
            </p>}
          </section>
        </section>
        <section className={filterOptionsStyle.filterOptions}>
          <section className={filterOptionsStyle.header}>
            <FormattedMessage id="stores.filter.title">{
              text => <p className={filterOptionsStyle.title}><i className={icons.symbolTweak}/>{text}</p>
            }</FormattedMessage>
            <section className={classNames(commonStyle.titleWrap, commonStyle.desktop)}>
              <i className={icons.iconBoxMedium}/>
              <section className={commonStyle.content}>
                <FormattedMessage id="flight.requests.title">{
                  txt => <h3 className={commonStyle.title}>{txt}</h3>
                }</FormattedMessage>
                {flight && <p className={commonStyle.subtitle}>
                  {flight.departureAdmin1.name} - {flight.arrivalAdmin1.name}
                </p>}
              </section>
            </section>
            <section className={filterOptionsStyle.sortOptions}>
              <FormattedMessage id="sort.title">{
                txt => <label>{txt}</label>
              }</FormattedMessage>
              {sortNativeSelect}
              {/*<i className={classNames(filterOptionsStyle.down, icons.iconChevronDownMedium)}/>
              <i className={classNames(filterOptionsStyle.up, icons.iconChevronUpMedium)}/>*/}
            </section>
            <section className={filterOptionsStyle.filterDrawer}>
              <FilterDrawer drawerOpen={drawerOpen}
                            filterFields={(this.generateFilterFields(categories, stores,
                              this.state, false): any)}
                            color="orange"
                            handleCloseDrawer={this.handleCloseDrawer}
                            handleOpenDrawer={this.handleOpenDrawer}
                            handleClearFilters={this.handleClearFilters}/>
            </section>
          </section>
        </section>
        <section className={commonStyle.mainWrap}>
          <aside className={commonStyle.filterWrap}>
            {filterContent}
          </aside>
          <section className={commonStyle.rightWrap}>
            <AlertContainer showId="flight"/>
            {!!tags.length && <ul className={filterStyles.tags}>
              {tags}
            </ul>}
            <Desktop>
              <div style={{textAlign: 'right'}}>
                {flight && user && <FlightShare flight={flight}
                                                user={user}
                                                open={shareFlightModalOpen}
                                                handleClose={() => this.setState({shareFlightModalOpen: false})}
                                                handleOpen={() => this.setState({shareFlightModalOpen: true})}/>}
              </div>
              <br/>
              <br/>
            </Desktop>
            <section className={style.tabsWrap}>
              {false && localeState.domainCountry === 'PE' &&
              <article className={style.tab}>
                <AwardCounter isFetchingReward={isFetchingReward}
                              travelerReward={travelerReward}/>
              </article>}
              <article className={style.tab}>
                <ProductsLimits localeState={localeState}/>
              </article>
            </section>
            {dateTooFarError &&
            <FormattedMessage id="flight.requests.error.dateTooFar">{
              txt => <p className={style.dateTooFar}>{txt}</p>
            }</FormattedMessage>}
            <InfiniteScroll offset={350}
                            disabled={isFetchingAvailable || !canAsk}
                            handleCheckpoint={() => fetchAvailableRequests(this.urlIdFlight, this.buildQueryParams())}>
              <section className={style.ordersWrap}>
                {orders}
              </section>
            </InfiniteScroll>
            {isFetchingAvailable && <Loading className={commonStyle.loading} color="orange"/>}
          </section>
        </section>
        <Modal handleClose={() => this.setState({ alreadyBookedModalOpen: false })}
               open={alreadyBookedModalOpen}
               showCloseButton={true}
               big>
          <div className={style.errorModalWrap}>
            <FormattedMessage id="flight.requests.error.alreadyBooked">{
              txt => <h3 className={style.errorModalTitle}>{txt}</h3>
            }</FormattedMessage>
            <img src={yogi}
                 alt="yogi"/>
            <FormattedMessage id="flight.requests.error.alreadyBooked.btn">{
              txt => <button className={classNames(buttonStyle.btn, buttonStyle.orange, style.button)}>{txt}</button>
            }</FormattedMessage>
          </div>
        </Modal>
      </Fragment>);
  }
}

OrderRequest.propTypes = {
  resetOrderRequestsState: PropTypes.func.isRequired,
  localeState: PropTypes.object.isRequired,
  localValues: PropTypes.object.isRequired,
  page: PropTypes.number,
  canAsk: PropTypes.bool,
  availableOrders: PropTypes.array,
  isFetchingAvailable: PropTypes.bool,
  fetchAvailableRequests: PropTypes.func.isRequired,
  fetchRequestsError: PropTypes.object,
  match: PropTypes.object.isRequired,
  fetchOnlineStores: PropTypes.func.isRequired,
  fetchFlightTravelerReward: PropTypes.func.isRequired,
  isFetchingReward: PropTypes.bool,
  travelerReward: PropTypes.object,
  //isFetchingOnlineStores: PropTypes.bool,
  //onlineStores: PropTypes.array,
  //fetchOnlineStoresError: PropTypes.object,
  resetAlertState: PropTypes.func.isRequired,
  user: PropTypes.object,
};

OrderRequest.contextTypes = {
  intl: intlShape,
};



// WEBPACK FOOTER //
// ./src/modules/flight/components/OrdersRequests/OrdersRequests.jsx